<template>
  <div
    class="page_container addCommondity"
    v-loading="loading"
    element-loading-text="提交中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >促销优惠&市场活动</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/shopIndex' }"
          >市场活动管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{
          formData.id == "" ? "新增市场活动" : "基础信息设置"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="form_container">
      <h1>{{ formData.id == "" ? "新增市场活动" : "基础信息设置" }}</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>活动名称：</p>
            <div class="input_box">
              <el-input
                v-model="formData.actname"
                placeholder="输入活动名称"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>活动封面（缩略图）</p>
            <p class="red">JPG或者PNG格式，尺寸比例为500*500像素</p>
            <div
              class="upload_box"
              @mouseenter="enter(1)"
              @mouseleave="creenIndex = ''"
            >
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="formData.actcover">
                  <img :src="baseUrl + formData.actcover" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 1"
                  >
                    <span
                      @click.stop="
                        handlePictureCardPreview(baseUrl + formData.actcover, 1)
                      "
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="handleRemove(1)"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>活动城市：</p>
            <div class="select_box">
              <el-select v-model="formData.city" placeholder="请选择活动城市">
                <el-option
                  v-for="item in provinceList"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaname"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>活动地标：</p>
            <div class="select_box">
              <el-input
                v-model="formData.position"
                placeholder="请输入活动地标"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>活动关联门店ID</p>
            <div class="select_box">
              <el-select
                v-model="formData.shopcode"
                placeholder="请选择活动关联门店ID"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.shopcode"
                  :label="item.shopname"
                  :value="item.shopcode"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block flex-between">
            <div>
              <p><span class="mark">*</span>开始预约日期：</p>
              <div class="input_box">
                <el-date-picker
                  v-model="formData.joinsdate"
                  type="datetime"
                  value-format="yyyy/MM/dd HH:mm:ss"
                  placeholder="开始预约日期"
                >
                </el-date-picker>
              </div>
            </div>
            <div>
              <p><span class="mark">*</span>结束预约日期：</p>
              <div class="input_box">
                <el-date-picker
                  v-model="formData.joinedate"
                  type="datetime"
                  value-format="yyyy/MM/dd HH:mm:ss"
                  placeholder="选择结束预约日期"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="block flex-between">
            <div>
              <p><span class="mark">*</span>活动开始日期&时间：</p>
              <div class="input_box">
                <el-date-picker
                  v-model="formData.sdate"
                  type="datetime"
                  value-format="yyyy/MM/dd HH:mm:ss"
                  placeholder="选择活动结束日期&时间"
                >
                </el-date-picker>
              </div>
            </div>
            <div>
              <p><span class="mark">*</span>活动结束日期&时间：</p>
              <div class="input_box">
                <el-date-picker
                  v-model="formData.edate"
                  type="datetime"
                  value-format="yyyy/MM/dd HH:mm:ss"
                  placeholder="选择活动结束日期&时间"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>活动花费类型：</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.costtype">
                <el-radio label="免费">免费</el-radio>
                <!-- <el-radio label="现金报名">现金报名</el-radio> -->
                <el-radio label="普通用户积分报名">普通用户积分报名</el-radio>
              </el-radio-group>
            </div>
            <div class="input_box" style="margin-top: 10px" v-if="formData.costtype != '免费'">
                <el-input
                v-model="formData.costval"
                placeholder="请输入活动花费值"
              ></el-input>
              </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>是否消耗会员权益次数参加：</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.isactpermis">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </div>
          </div>
          <!-- <div class="block">
            <p><span class="mark">*</span>企业关联业务端场景APPID</p>
            <div class="select_box">
              <el-select
                v-model="formData.linkappid"
                placeholder="请选择企业关联业务端场景APPID"
              >
                <el-option
                  v-for="item in appList"
                  :key="item.appid"
                  :label="item.wechatname"
                  :value="item.appid"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->
        </div>
        <div class="tip_wrap"></div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!-- 主要内容 end -->

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  uploadPosterImage,
  getShopList,
  getProvince,
  encryptstringview,
  getAppList,
} from "../../api/api";
import { getActivityDetail, editActivity, addActivity } from "../../api/shop";
export default {
  name: "addShop",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      searchText: "",

      loading: false,
      barndId: "", // 选中品牌id
      brandName: "", // 选中品牌name
      brandItem: "", // 选中品牌item
      brandList: "", // 品牌列表
      formData: {
        id: "",
        appid: '', 
        actname: "",
        actcover: "",
        city: "",
        position: "",
        shopcode: "",
        joinsdate: "", // 开始预约日期
        joinedate: "", // 结束预约日期
        sdate: "", // 活动开始日期&时间
        edate: "", // 活动结束日期&时间
        costtype: "", // 活动花费类型 =现金报名 普通用户积分报名
        costval: 0,  // 活动花费值
        isactpermis: "", // 是否消耗权益码 =是 否

        openid: "", // 创建人openid
        truename: "", // 创建人姓名
        mobile: "", // 创建人手机号
        qyguid: "", // 创建人所属企业guid
        linkappid: "", // 企业关联业务端场景APPID
      },
      appList: [], // 所有app业务场景
      provinceList: [], // 活动城市
      shopList: [], // 门店列表
      creenIndex: 1,
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.formData.openid = USERINFO.openid;
    this.formData.truename = USERINFO.truename
      ? USERINFO.truename
      : USERINFO.nickname;
    this.formData.mobile = USERINFO.mobile;
    if (USERINFO.qy) {
      this.formData.qyguid = USERINFO.qy.qyguid;
      this.formData.linkappid = USERINFO.qy.postappid;
      this.formData.appid = USERINFO.qy.postappid;
    } else {
      this.formData.qyguid = 0;
    }
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") {
        this.getProvince();
        this.getShopList();
        this.getAppList();
      } else {
        this.encryptstringview(routerList[name].encryptstring, OPENID);
      }
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.id = id;
        this.getActivityDetail(id);
      } else {
        this.$router.back();
      }
    },

    // 获取活动详情
    getActivityDetail(id) {
      getActivityDetail({ id }).then((res) => {
        this.formData.actname = res.actname;
        this.formData.actcover = res.actcover.split('upload')[1];
        this.formData.city = res.city;
        this.formData.position = res.position;
        this.formData.shopcode = res.shopcode;
        this.formData.joinsdate = res.joinsdate;
        this.formData.joinedate = res.joinedate;
        this.formData.sdate = res.sdate;
        this.formData.edate = res.edate;
        this.formData.costtype = res.costtype;
        this.formData.isactpermis = res.isactpermis;
        this.getProvince();
        this.getShopList();
        this.getAppList();
      });
    },

    // 获取app列表
    getAppList() {
      getAppList().then((res) => {
        this.appList = res;
      });
    },

    // 获取门店列表
    getShopList() {
      let params = {
        Page: 1,
        PageSize: 100,
        qyguid: this.formData.qyguid,
      };
      getShopList(params).then((res) => {
        this.shopList = res;
      });
    },

    // 获取城市
    getProvince() {
      getProvince().then((res) => {
        this.provinceList = res;
      });
    },

    // 移出图片
    handleRemove(isType) {
      if (isType == 1) {
        this.formData.actcover = "";
      }
    },
    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 移入图片区域
    enter(type) {
      this.creenIndex = type;
    },

    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      let { creenIndex } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadPosterImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          if (creenIndex == 1) {
            this.formData.actcover = res.code;
          }
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 返回上一页
    handleReturn() {
      this.$router.push({ name: "shopIndex" });
    },

    // 提交数据
    query() {
      let { formData } = this;

      if (formData.actname == "") {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (formData.actcover == "") {
        this.$message.warning("请上传活动封面（缩略图）");
        return;
      }
      if (formData.city == "") {
        this.$message.warning("请输入活动城市");
        return;
      }
      if (formData.position == "") {
        this.$message.warning("请输入活动地标");
        return;
      }
      if (formData.shopcode == "") {
        this.$message.warning("请选择活动关联门店ID");
        return;
      }
      if (formData.joinsdate == "") {
        this.$message.warning("请选择开始预约日期");
        return;
      }
      if (formData.joinedate == "") {
        this.$message.warning("请选择结束预约日期");
        return;
      }
      if (formData.sdate == "") {
        this.$message.warning("请选择活动开始日期&时间");
        return;
      }
      if (formData.edate == "") {
        this.$message.warning("请选择活动结束日期&时间");
        return;
      }
      if (formData.costtype == "") {
        this.$message.warning("请选择活动花费类型");
        return;
      }
      if (formData.isactpermis == "") {
        this.$message.warning("请选择是否消耗权益码");
        return;
      }
      this.loading = true;

      if (formData.id == "") {
        this.loading = true;
        addActivity(formData).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      } else {
        this.loading = true;
        editActivity(formData).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.loading = false;
              this.$message.success(res.message);
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.addCommondity {
  .form_container {
    h1 {
      font-size: 20px;
      color: #404d6c;
      margin-bottom: 28px;
    }
    .content_wrap {
      align-items: flex-start;
      .form_wrap {
        flex: 1;
        margin-right: 100px;
        .block {
          margin-bottom: 45px;
          .input_box {
            margin-bottom: 20px;
          }
        }
      }
      .tip_wrap {
        flex: 1;
      }
      p {
        font-size: 18px;
        color: #6e6e6e;
        margin-bottom: 8px;
        &.red {
          font-size: 16px;
          color: #ff0012;
          line-height: 26px;
          // margin-bottom: 0;
        }
        .mark {
          color: #ff0012;
          font-size: 14px;
          margin-right: 4px;
        }
      }
    }
  }
  .custom_wrap {
    .diaog_head {
      height: 80px;
      h1 {
        font-size: 18px;
        color: #6e6e6e;
      }
      p {
        font-size: 14px;
        color: #ff0012;
        margin: 10px 0 8px;
      }
    }
    .diaog_body {
      // height: calc(68vh - 160px);
      .radio_wrap {
        .radio_group {
          flex-wrap: wrap;
          .radio_item {
            margin-right: 80px;
            font-size: 14px;
            color: #6e6e6e;
            margin-bottom: 20px;
            cursor: pointer;
            .iconfont {
              font-size: 22px;
              margin-right: 5px;
              color: #a5a5a5;
              &.icon-danxuanyixuan1 {
                color: #ea4e4e;
              }
            }
          }
        }
      }
    }
    .dialog_footer {
      .link {
        a {
          font-size: 16px;
          color: #fe3c46;
        }
      }
    }
  }
}
</style>